import { useMsal } from '@azure/msal-react';
import { msalConfigSignIn } from '../auth/signInAuthConfig';
import { appInsights } from '../auth/appInsight';
import { postSessionData } from './useUserAuthentication';
import useDataJson from '../freedomHooks/useDataJson';
import { useSelector } from 'react-redux';
import { loggingSticker } from '../FreedomConstants/freedomConstants';

const useLogout = () => {
  const { instance } = useMsal();
  const {jsonPrefix} = useDataJson();
  const {accessToken} = useSelector((state) => state.user.user)
  const handleLogOutRedirect = async () => {
    postSessionData(jsonPrefix, accessToken, loggingSticker?.Logout);
    let browserName = window.navigator.userAgent;
    if (browserName.indexOf('Chrome') > -1 || browserName.indexOf('Edge') > -1 || browserName.indexOf('Opera') > -1 || browserName.indexOf('OPR') > -1) {
      sessionStorage.clear();
      localStorage.clear();
      await instance.logoutRedirect({
        postLogoutRedirectUri: msalConfigSignIn.auth.postLogoutRedirectUri
      });
    }
    if (browserName.indexOf('Firefox') > -1 || browserName.indexOf('Safari') > -1) {
      await instance.logoutRedirect({
        postLogoutRedirectUri: msalConfigSignIn.auth.postLogoutRedirectUri
      });
    }
  };
  try {
    return { handleLogOutRedirect };
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};

export default useLogout;
